import Vue from 'vue'
import App from './App'
import router from './router'
import VueResource from 'vue-resource'
import Vue2TouchEvents from 'vue2-touch-events'
import axios from 'axios'
import moment from 'moment'
import VueMomentJS from 'vue-momentjs'
import VuejsDialog from 'vuejs-dialog'
import vmodal from 'vue-js-modal'
import ToggleButton from 'vue-js-toggle-button'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import vuetify from '@/plugins/vuetify'
import 'vue-select/dist/vue-select.css'

import 'material-icons/iconfont/material-icons.css'
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/css/froala_style.min.css";
import "froala-editor/js/plugins.pkgd.min.js";

import VueFroala from 'vue-froala-wysiwyg'
window.$ = window.jQuery = require('jquery')

const url = `${window.location.protocol}//rest.ahlpoker.com/`
axios.defaults.baseURL = url

Vue.use(VueResource)
Vue.use(Vue2TouchEvents)
Vue.use(VueFroala)
Vue.use(VueMomentJS, moment)
Vue.use(VuejsDialog)
Vue.use(vmodal, {dynamic: true})
Vue.use(ToggleButton)
Vue.config.productionTip = false

Vue.config.productionTip = false;

new Vue({
    router,
    vuetify,
    render: h => h(App)
}).$mount("#app");

